<div class="modal-header" mat-dialog-title>
  <div class="modal-header-icon">
    <mat-icon class="material-symbols-outlined">inventory_2</mat-icon>
  </div>
  <div class="modal-header-titles">
    <h2 class="modal-title">Lançamento de múltiplos</h2>
    <p class="modal-subtitle">Itens</p>
  </div>
  <div class="modal-header-close-btn-container">
    <button mat-icon-button type="button" class="modal-close-btn" aria-label="Fechar"
      (click)="cancelar()">
      <mat-icon class="material-symbols-outlined">close</mat-icon>
    </button>
  </div>
</div>

<mat-dialog-content class="vmd-conteudo" [formGroup]="form">
  <!-- O que está sendo lançado: SKU e descrição, em leitura (§6.2.3). -->
  <div class="vmd-cabecalho">
    <span class="vmd-badge">Múltiplo</span>
    <div class="vmd-identificacao">
      <span class="vmd-nome">{{ data.descricao }}</span>
      <span class="vmd-apoio">
        @if (data.codigoSku) { SKU {{ data.codigoSku }} · }
        vendido em {{ data.regra.unidadeMultiplo || 'múltiplos' }} de
        {{ data.regra.fatorMultiplo | abnt: 'quantidade' }} {{ data.unidade || '' }}
      </span>
    </div>
  </div>

  <div class="row vmd-campos">
    <div class="col-12 col-md-4">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>{{ rotuloUnidades }}</mat-label>
        <input matInput formControlName="unidades" [currencyMask]="data.mascaraQuantidade" class="vmd-num"
          inputmode="decimal" cdkFocusInitial>
        @if (form.get('unidades')?.hasError('quantidadeFracionada') && form.get('unidades')?.touched) {
          <mat-error>
            {{ quantidade | abnt: 'quantidade' }} {{ data.unidade || '' }} não é inteiro e a unidade não aceita fração.
            Ajuste a quantidade ou o fator do múltiplo no cadastro do produto.
          </mat-error>
        } @else if (form.get('unidades')?.invalid && form.get('unidades')?.touched) {
          <mat-error>Informe uma quantidade maior que zero.</mat-error>
        }
      </mat-form-field>
    </div>

    <div class="col-12 col-md-4">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Múltiplo</mat-label>
        <input matInput [value]="data.regra.fatorMultiplo | abnt: 'quantidade'" readonly class="vmd-num">
        <mat-hint>Fator do cadastro.</mat-hint>
      </mat-form-field>
    </div>

    <div class="col-12 col-md-4">
      <mat-form-field appearance="outline" class="w-100 vmd-resultado">
        <mat-label>Quantidade</mat-label>
        <input matInput [value]="quantidade | abnt: 'quantidade'" readonly class="vmd-num vmd-forte">
        @if (data.unidade) {
          <span matSuffix class="vmd-sufixo">{{ data.unidade }}</span>
        }
        <mat-hint>{{ rotuloUnidades }} × múltiplo.</mat-hint>
      </mat-form-field>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="vmd-acoes">
  <button type="button" mat-stroked-button class="btn-secondary" (click)="cancelar()">Cancelar</button>
  <button type="button" mat-flat-button class="btn-primary" (click)="confirmar()">Confirmar</button>
</mat-dialog-actions>
